<template>
  <el-dialog
    title="Timeslot collection stats"
    :visible.sync="modalVisible"
    @close="onResetForm"
    width="75%">
    <div v-if="timeslotCollectionId">
      <h1>{{timeslotCollection.name}}</h1>
      <!-- TODO:
      Display planned vs used time here
      -->
      <pre v-if="SHOW_DEBUG">{{timeslotCollection}}</pre>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data: () => ({
    timeslotCollectionId: null,
    modalVisible: false,
  }),
  computed: {
    timeslotCollection() {
      return this.timeslotCollectionId
             ? this.$models.timeslotCollection.getNode( this.timeslotCollectionId )
             : null;
    },
  },
  methods: {
    showModal({ timeslotCollectionId }) {
      this.modalVisible = true;
      this.timeslotCollectionId = timeslotCollectionId;
    },
    onResetForm() {
      this.timeslotCollectionId = null;
    },
  },
}
</script>
